/* Prepare Barracuda funcitons set */
var Barracuda = {};

/* general functions */
function prevent(event) {
   if (event) event.preventDefault();
}

/* Show window dimensions in corner */
Barracuda.createStats = function (){
   var stats = document.querySelector(".stats");
   if(stats){
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
      const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
      const scrollbarWidth = window.innerWidth - document.body.clientWidth;
      stats.innerHTML = "" + vw + " px<br>"+ vh +" px<br>"+ (scrollbarWidth>30? "<s>"+scrollbarWidth+"px</s>": scrollbarWidth + "px");
      
      if(document.querySelector(".overlay")){
      document.querySelector(".overlay").style.width = vw + "px";
      document.querySelector(".overlay").style.height = vh + "px";
      }
   }
}

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) {
          return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
  }
    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
};

/* Cookies functions */
function getCookie(cname) {
   let name = cname + "=";
   let decodedCookie = decodeURIComponent(document.cookie);
   let ca = decodedCookie.split(';');
   for(let i = 0; i <ca.length; i++) {
   let c = ca[i];
   while (c.charAt(0) == ' ') {
      c = c.substring(1);
   }
   if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
   }
   }
   return "";
}

function setCookie(cname, cvalue, exdays) {
   const d = new Date();
   d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
   let expires = "expires="+d.toUTCString();
   document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

/* overlay actions */
function overlayClick(event, force = false) {
   if (force || (event.target.classList && (event.target.classList.contains("overlay") || event.target.closest("a") && event.target.closest("a").classList.contains("overlay-closer"))) )
   { document.querySelector("body").classList.remove("show-overlay");
   unlockBodyPosition();}
}

/* Topbar actions */
function openTopbar(event, targetName){
   prevent(event);
   target = document.getElementById(targetName);
   if(target){ 
      target.removeAttribute("hidden");
      setTimeout(function(){
         target.classList.add("visible");
         if(targetName == "menu"){ 
            setTimeout(Barracuda.elements.mainMenu.hideMenuLinks.bind(Barracuda.elements.mainMenu), 2); 
            setTimeout(Barracuda.elements.mainMenu.showMenuLinks.bind(Barracuda.elements.mainMenu), 150)
         }
         lockBodyPosition();
         var focusTarget = target.querySelector(".topbar-focus");
         if(focusTarget){ 
            focusTarget.focus();
         }
      },50)
   }
}
function closeTopbar(event) {
   document.querySelectorAll(".topbar.visible").forEach(el=>{

      el.classList.remove("visible");
      setTimeout(function(){el.setAttribute("hidden", true)}, 600);
   })
   if(document.querySelector(".topbar #auth-form"))
      document.querySelector(".topbar #auth-form").innerHTML = "";
   unlockBodyPosition();
}

/* Functions for blocking scroll when overlay is visible */
function noScroll(event) {
   var inside = event.target.closest(".scroll-inside");
   if(inside && event.deltaY){
      if(event.deltaY > 0 && inside.scrollTop + inside.offsetHeight < inside.scrollHeight){
      }else if(event.deltaY < 0 && inside.scrollTop > 0){
      }else{
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();}
   }
}
function noScrollTouchMove(event) {
   var inside = event.target.closest(".scroll-inside");
   if(inside){
      var noScrollTouchEnd = event.changedTouches[0].clientY;
      if (noScrollTouchStartClientY > noScrollTouchEnd && inside.scrollTop + inside.offsetHeight < inside.scrollHeight) {
      } else if ((noScrollTouchStartClientY < noScrollTouchEnd) && inside.scrollTop > 0) {
      }else{
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();}
   }
}
function noScrollTouchStart(event){
   noScrollTouchStartClientY = event.touches[0].clientY
}

var bodyPostionY = null;
var noScrollTouchStartClientY = null;
/* lock body scroll */
function lockBodyPosition() {
      Barracuda.setScrollBarWidth();
      document.querySelector("body").classList.add("no-scroll");
      // add listener to disable scroll
      document.querySelectorAll(".scroll-inside").forEach(el=>{
         el.addEventListener('mousewheel', noScroll, false);
         el.addEventListener('touchstart', noScrollTouchStart, false);
         el.addEventListener('touchmove', noScrollTouchMove, false);
      });
}
function unlockBodyPosition() {
   document.querySelector("body").classList.remove("no-scroll");
   window.removeEventListener('mousewheel', noScroll);
   window.removeEventListener('touchstart', noScrollTouchStart);
   window.removeEventListener('touchmove', noScrollTouchMove);

}

/* menu actions */
function openSubmenu(event){
   prevent(event);
   var parentLi = event.target.closest("li");
   var height = parentLi.querySelector("ul").style.maxHeight

   parentLi.classList.toggle("open");
   if(height == "") parentLi.querySelector("ul").style.maxHeight = parentLi.querySelector("ul").scrollHeight + "px";
   else parentLi.querySelector("ul").style.maxHeight = "";

   var parentUl = event.target.closest("ul");
   if(parentUl.classList.contains("child")) parentUl.style.maxHeight = (parentUl.scrollHeight + parentLi.querySelector("ul").scrollHeight) + "px";
   
}

/* Fade functions */
Barracuda.duration = 300;
Barracuda.fadeOut = function(el, after = null, time = Barracuda.duration) {
   if(!el.dataset.animated || el.dataset.animated == "false"){
      el.dataset.animated = true;
      el.style.opacity = 1;
      (function fadeOutTemp(){
            el.style.opacity = parseFloat(el.style.opacity) - .02
         if ((el.style.opacity)<0){
            el.classList.add("hide");
            el.dataset.animated = false;
            el.style.opacity = 0;
            if(after) after();}
         else {
            setTimeout(fadeOutTemp,(time / 50))
         }
      })();
   }
};

Barracuda.fadeIn = function(el, after = null, time = Barracuda.duration) {
   if(!el.dataset.animated || el.dataset.animated == "false"){
      el.dataset.animated = true;
      el.style.opacity = 0;
      el.classList.remove("hide");
      (function fadeInTemp(){
            el.style.opacity = parseFloat(el.style.opacity) + .02
         if ((el.style.opacity)>1){
            el.dataset.animated = false;
            el.style.opacity = 1;
            if(after) after();}
         else {
            setTimeout(fadeInTemp,(time / 50))
         }
      })();
   }
}

/* Define methods for dynamic loaded sections */
Barracuda.loadSection = function(){
   document.querySelectorAll(".load-section:not(.initialized)").forEach(el=>{
      console.log("loading section")
      el.classList.add("initialized");
      el.addEventListener("click",(e)=>{
         prevent(e);
         var currentContent = document.querySelector(".overlay-content-content>form, .overlay-content-content>div");
         if(currentContent && currentContent.dataset.source){
            var t = document.querySelector("#"+currentContent.dataset.source);
            /* console.log("Return this: ", currentContent, " into this: ", t); */
            if(t) t.appendChild(currentContent);
         }

         var targetElement = el.dataset.target? (document.querySelector("#"+el.dataset.target)? document.querySelector("#"+el.dataset.target): false) : false

         if(!targetElement){
            document.querySelector(".overlay-content").innerHTML = "";
            document.querySelector(".overlay-content").classList.add("loading")
            document.querySelector("body").classList.add("show-overlay");
            lockBodyPosition();
         }

         var url =  window.location.href;
         if(el.dataset.url){
            var url = el.dataset.url;
         } 
         if((!el.dataset.url && el.closest("form") )|| el.dataset.useform){
            var url = url.split("#")
            var url = url[0] + (url[0].includes("?") ? "&" : "?") + new URLSearchParams(Array.from(new FormData(el.closest("form"))));
         }

         var url = url.split("#")
         var url_section = url[0] + (url[0].includes("?") ? "&" : "?") + "sections=" + el.dataset.section;
         if(el.dataset.urlset)
         { 
            window.history.pushState('', '', url[0]);
         }
         /* console.log("LoadSection: " + url_section); */
         axios.get(url_section)
         .then(function (response) {
            var code = response.data? (response.data[el.dataset.section]? response.data[el.dataset.section] : false):false;
            if (code){
               code = code.replace(/__CURRENT_URL_WITH_APPEND__/g, url[0] + (url[0].includes("?") ? "&" : "?"));
               code = code.replace(/__CURRENT_URL__/g, url[0]);

               if(targetElement){
                  targetElement.classList.remove("loading")

                  if(targetElement.innerHTML!=""){
                     Barracuda.fadeOut(targetElement, (()=>{
                        if(el.dataset.part){
                           var candidate = document.createElement("div");
                           candidate.innerHTML = code;
                           code = candidate.querySelector("."+el.dataset.part);
                           targetElement.innerHTML = "";
                           targetElement.appendChild(code);
                        }else{
                           targetElement.innerHTML = code;
                        }
                        Barracuda.init();
                        Barracuda.elements.init();
                        
                        Barracuda.fadeIn(targetElement,Barracuda.setScrollBarWidth)
                     }).bind(this))
                  }else{
                     if(el.dataset.part){
                        var candidate = document.createElement("div");
                        candidate.innerHTML = code;
                        code = candidate.querySelector("."+el.dataset.part);
                        targetElement.innerHTML = "";
                        targetElement.appendChild(code);
                     }else{
                        targetElement.innerHTML = code;
                     }
                     Barracuda.init();
                     Barracuda.elements.init();
                     Barracuda.setScrollBarWidth();
                  }

               }else{
                  document.querySelector(".overlay-content").classList.remove("loading")
                  document.querySelector(".overlay-content").innerHTML = code;
                  lockBodyPosition();
               }
                  Barracuda.init();
                  Barracuda.elements.init();
            } 
         })
         .catch(function (error) {
            if(!targetElement){
               document.querySelector("body").classList.remove("show-overlay");
               document.querySelector(".overlay-content").classList.remove("loading")
            }
            console.warn(error);
         });
         return false;
      },false)
   });
}

/* Dynamic load page - part page */
Barracuda.loadPage = function(){
   document.querySelectorAll(".load-page:not(.initialized)").forEach(el=>{
      el.classList.add("initialized");
      el.addEventListener("click",(e)=>{
         prevent(e);

         var targetElement = el.dataset.target? (document.querySelector("#"+el.dataset.target)? document.querySelector("#"+el.dataset.target): false) : false
         var sourceId = el.dataset.source? el.dataset.source : (el.dataset.target? el.dataset.target: false);
         var url = el.dataset.url? el.dataset.url : (el.href? el.href : false);
         url = (url.split("#"))[0];
         
         if(el.dataset.urlset && el.closest(".topbar")==null) window.history.pushState('', '', url);
         
         if(targetElement && sourceId && url){
            /* console.log("BarracudaLoadPage: urlset: "+el.dataset.urlset+", url: "+ url +", sourceId: #"+sourceId+", target:", targetElement) */
            targetElement.classList.add("loading");

            if(sourceId == "pagination"){
               /* console.log("BarracudaLoadPage: Pagination - scroll up ", targetElement.offsetTop) */
               if(targetElement.offsetTop - 200 < 200)
                  window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
               else
                  window.scrollTo({top: (targetElement.offsetTop - 200), left: 0, behavior: 'smooth'})

            }

            axios.get(url)
            .then(function (response) {
               if(response.data){
                  var x = document.createElement("html");
                  x.innerHTML = response.data;
                  var source = x.querySelector("#"+ sourceId);
                  if(source){
                     el.parentElement.querySelectorAll(".load-page.active").forEach(function (y){
                        y.classList.remove("active");
                     })
                     el.classList.add("active")
                     
                     Barracuda.fadeOut(targetElement, (()=>{
                        if(sourceId != "pagination"){
                           targetElement.innerHTML = "";
                           targetElement.appendChild(source);
                        }else{
                           source.classList.add("hide", "loading")
                           targetElement.replaceWith(source);
                           targetElement = source;
                        }
                        targetElement.classList.remove("loading")

                        Barracuda.init();
                        Barracuda.elements.init();

                        Barracuda.fadeIn(targetElement, Barracuda.setScrollBarWidth)
                     }).bind(this))
                  }
                  return false;
               }
               return false;
            })
            .catch(function (error) {
               console.error(error);
            });
         }
         return false;
      },false)
   });
}
/* Show template in overlay */
Barracuda.templateOverlay = function(){
   document.querySelectorAll(".template-overlay:not(.initialized)").forEach(el=>{
      el.classList.add("initialized");
      el.addEventListener("click",(e)=>{
         prevent(e);
         var template = document.getElementById(el.dataset.source);

         if(template){
            document.querySelector("body").classList.add("show-overlay");
            document.querySelector(".overlay-content").classList.add("loading");
            lockBodyPosition();
   
            var currentContent = document.querySelector(".overlay-content-content>form, .overlay-content-content>div");
            var target = document.querySelector(".overlay-content")
               
            if(currentContent && currentContent.dataset.source && document.querySelector("#"+currentContent.dataset.source))
               document.querySelector("#"+currentContent.dataset.source).appendChild(currentContent);

            target.innerHTML = "";

            setTimeout(()=>{
               var closer = document.createElement("a");
               closer.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'
               closer.classList.add("icon","icon-x","overlay-closer");
               
               var content = document.createElement("div");
               content.innerHTML = template.innerHTML;
               content.classList.add("overlay-content-content","quick-view","quick-view-form","scroll-inside");
               if (template.dataset.type) content.classList.add(template.dataset.type);
               
               target.appendChild(closer);
               target.appendChild(content);

               if(content.querySelector(".map")){
                  setTimeout(function() { 
                     Barracuda.loadMapsScript(content);
                  },200);
               }

               Barracuda.init();
               Barracuda.elements.init();
               document.querySelector(".overlay-content").classList.remove("loading");
            },500)
         }
      })
   })
}
/* Show form in overlay */
Barracuda.formOverlay = function(){
   document.querySelectorAll(".form-overlay:not(.initialized)").forEach(el=>{
      el.classList.add("initialized");
      el.addEventListener("click",(e)=>{
         prevent(e);

         var newSource = document.querySelector("#"+el.dataset.source+">form, #"+el.dataset.source+">div")? document.querySelector("#"+el.dataset.source+">form, #"+el.dataset.source+">div") : false;
         
         document.querySelector("body").classList.add("show-overlay");
         document.querySelector(".overlay-content").classList.add("loading");
         lockBodyPosition();

         if(newSource){
            if(newSource.querySelector(".map") && !document.getElementById("ol-script")){
               Barracuda.loadMapsScript();
            }

            var currentContent = document.querySelector(".overlay-content-content>form, .overlay-content-content>div");
            var target = document.querySelector(".overlay-content")
            

            if( currentContent == null|| currentContent && currentContent.dataset.source != el.dataset.source){
               if(currentContent && currentContent.dataset.source){
                  var t = document.querySelector("#"+currentContent.dataset.source);
                  t.appendChild(currentContent);
               }
               newSource.dataset.source = el.dataset.source;
               target.innerHTML = "";

               var closer = document.createElement("a");
               closer.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'
               closer.classList.add("icon","icon-x","overlay-closer");
               
               var content = document.createElement("div");
               content.classList.add("overlay-content-content","quick-view","quick-view-form","scroll-inside");
               if (newSource.dataset.type) content.classList.add(newSource.dataset.type);

               content.appendChild(newSource)

               if(content.querySelector(".map")){
                  setTimeout(function() {
                     Barracuda.loadMapsScript(content);
                  },110);
               }

               target.appendChild(closer);
               target.appendChild(content);

               setTimeout(function() {
                  document.querySelector(".overlay-content").classList.remove("loading");
               },100)

            }else{

            document.querySelector(".overlay-content").classList.remove("loading");
            }
         }else{

            setTimeout(function() {
               document.querySelector(".overlay-content").classList.remove("loading");
            },100)
         }
      });
   });
}
/* Define methods for dynamic collapse elements */
Barracuda.toggleCollapsible = function(e) {
   prevent(e);
   var opener = e.target.closest(".collapse-toggle")
   if(opener){
      var element = document.getElementById(opener.dataset.target);
      if(element.classList.contains("collapsed")){
         element.style.height = element.scrollHeight + "px";
         element.classList.remove("collapsed");
         setTimeout(()=>{
            element.style.height = "auto";
         }, 500);
         opener.classList.add("opened");
      }else{
         element.style.height = element.scrollHeight + "px";
         setTimeout(()=>{
            element.style.height = 0 + "px";
         },10);
         element.classList.add("collapsed");
         opener.classList.remove("opened");
      }
   }
}

/* Add event listeners for dynamic collapse elements */
Barracuda.initCollapsible = function(){
   document.querySelectorAll(".collapse-toggle:not(.collapse-toggle-initialized)").forEach(el => {
      el.addEventListener("click",Barracuda.toggleCollapsible);
      el.classList.add("collapse-toggle-initialized");
   })
}

/* Create autoresize textarea element */
Barracuda.textareaAutoresize = function(){
   document.querySelectorAll("textarea.autoresize:not(.autoresize-initialized)").forEach(el => {
      el.addEventListener("keyup",(e)=>{
         e.target.style.height = "0px";
         e.target.style.height = (e.target.scrollHeight - (el.dataset.correction? el.dataset.correction : 26)) + "px";
      })
      el.classList.add("autoresize-initialized");
   })
}

/* Close section and save it to cookies */
Barracuda.cookieSection = function(){
   document.querySelectorAll(".hide-by-cookie-section:not(.hide-by-cookie-section-initialized)").forEach((el)=>{
      var dataEl = el.querySelector(".hide-by-coookie-data");
      var respawn_time = el.dataset.respawn? parseInt(el.dataset.respawn) : parseInt(dataEl? (dataEl.dataset.respawn? dataEl.dataset.respawn : 0) : 0);
   
      el.classList.add("hide-by-cookie-section-initialized")
      if(getCookie('cookie-'+el.id+'-'+respawn_time) != "closed" || Shopify.designMode){
         el.classList.remove("hide-by-cookie");
         el.querySelectorAll(".hide-by-cookie-toggle").forEach(toggle=>{
            toggle.addEventListener("click",()=>{
               if(el.querySelector(".badge-section")){
                  Barracuda.fadeOut(el.querySelector(".badge-section"),()=>{
                     el.classList.add("hide-by-cookies");
                  }, (Barracuda.duration * 2));
               }
               if(el.classList.contains("announcement-bar-content"))
               { 
                  el.style.height = parseInt(el.offsetHeight) + "px";
                  el.style.overflow = "hidden";
                  el.style.transition = "height 1s ease";
                  el.style.height = "0px";
                  setTimeout(function(){Barracuda.initAddHeight();
                  },10)

               }
               /* console.log("Cookies - element: ", el, " repsawn_time: ", respawn_time) */
               // respawn_time is in days
               if(respawn_time > 0) setCookie('cookie-'+el.id+'-'+respawn_time,"closed",respawn_time);
            },false);
         })
      }
   })
}

Barracuda.loadMapsScript = function(content = null){
   if(!document.getElementById("ol-script")){
      var tag = document.createElement("script");
      tag.id = "ol-script"
      tag.src = document.querySelector(".ol-url")? document.querySelector(".ol-url").dataset.url : "";
      document.getElementsByTagName("head")[0].appendChild(tag);

      window.removeEventListener("scroll", Barracuda.elements.lazyMapsListener)
   }else{
      if(content)
         content.querySelectorAll(".map.map-initialized").forEach(element => {
            element.dispatchEvent(new Event('renderMap'))
         })
      document.querySelectorAll(".map:not(.map-initialized)").forEach(element => {
         new BarracudaMap(element)
      })
   }
}
Barracuda.checkMaps = function(){
   if(typeof BarracudaMap === "undefined"){
      Barracuda.elements.lazyMaps.forEach((element, index)=>{
         if(!document.getElementById("ol-script") && element.getBoundingClientRect().top <= (window.innerHeight + window.scrollY)){
            Barracuda.loadMapsScript();
            window.removeEventListener("scroll", Barracuda.checkMaps, {passive: true});
         }
      })
   }
}
Barracuda.checkVideos = function(){
   Barracuda.elements.lazyVideos.forEach((element, index)=>{
   if(element.getBoundingClientRect().top <= (window.innerHeight + window.scrollY)){
      element.src = element.dataset.src;
      var video = element.closest("video");
      if(video && video.play && video.autoplay ) video.play();

      Barracuda.elements.lazyVideos.splice(index, 1);
      if(Barracuda.elements.lazyVideos.length==0) 
         window.removeEventListener("scroll", Barracuda.elements.lazyVideosListener)
   }
   })
}

/* Function which adding spaces between sections with differents backgrounds */
Barracuda.sectionPaddingForBackgroundsTwo = function(ignoreSection = false){
var type = "";
var first = false;
if(ignoreSection){
      var sections = document.querySelectorAll("#page-content>.shopify-section:not(#shopify-section-header):not(#"+ignoreSection.id+")");
}else{
   var sections = document.querySelectorAll("#page-content>.shopify-section:not(#shopify-section-header)");
}
sections.forEach((element, key, elements)=>{

   if(!first && !element.classList.contains("out-of-structure")){
      element.classList.add("first-of-content")
      first = true;
   }

   var child = element.querySelector(".section-with-padding,.section-without-padding");
   /*  console.log("First-of-type section: key: ",key," type-before:", type, " child:", child? child : "-", " child-type", child? child.dataset.background : "", " element:", element); */
   if(key == 0){
      //first element
      element.classList.add("first-of-type")
      type = child? child.dataset.background : "";
   }else{
      //if new component
      if(child){
      //if same type as previous
      if(child.dataset.background == type || type == "same"){
         element.classList.remove("first-of-type")
         type = child.dataset.background;
      }else{
         //otherwise set as first of type
         element.classList.add("first-of-type")
         type = child.dataset.background
      }
      }else{
      element.classList.add("first-of-type")
      type = "";
      }
   }
});
}

/* Function which keep elements squared. */
Barracuda.toSquare = function(){
   document.querySelectorAll(".square").forEach((element) => {
   var width = element.offsetWidth;
   /* console.log("square: ",element, "width: ",width) */
   element.style.height = width + "px";
   })
}

/* Functions which define css variable for announcement bar */
Barracuda.initAddHeight = function(){
   let root = document.documentElement;
   let el = document.querySelector(".announcement-bar");
   if(el){
      var addHeight = el.offsetHeight? el.offsetHeight : 0;
      root.style.setProperty('--announcement-bar-height', addHeight + "px");
   }
   let header = document.querySelector("#header>.header");
   if(header){
      var headerHeight = header.offsetHeight? header.offsetHeight : 0;
      root.style.setProperty('--header-height', headerHeight + "px");
   }
}

Barracuda.setScrollBarWidth = function(){
   if(!document.querySelector(".topbar.visible")){
      /* console.log("ScrollbarWidth: set to: ",`${window.innerWidth - document.body.clientWidth}px`) */
      const scrollbarWidth = window.innerWidth - document.body.clientWidth;
      if(scrollbarWidth < 60)
      document.body.style.setProperty(
         "--scrollbar-width",
         scrollbarWidth + "px"
      );
   }
}

/* Inicialization for barracuda functions */
Barracuda.init = function(){
   Barracuda.reInit();
      window.addEventListener("resize", ()=>{
         Barracuda.toSquare();
         Barracuda.setScrollBarWidth();
         Barracuda.initAddHeight();
      }); 
   if(Barracuda.elements.lazyVideos.length>0){
      Barracuda.elements.lazyVideosListener = window.addEventListener("scroll", Barracuda.checkVideos, {passive: true});
      setTimeout(Barracuda.checkVideos, 3000);
   }
   if(Barracuda.elements.lazyMaps.length>0){
      Barracuda.elements.lazyMapsListener = window.addEventListener("scroll", Barracuda.checkMaps, {passive: true});
      setTimeout(Barracuda.checkMaps, 3000);
   }
}
/* ReInit after Shopify Theme editor changes something  */
Barracuda.reInit = function(){
   Barracuda.cookieSection();
   Barracuda.initCollapsible();
   Barracuda.loadSection();
   Barracuda.loadPage();
   Barracuda.sectionPaddingForBackgroundsTwo();
   Barracuda.textareaAutoresize(); 
   Barracuda.toSquare();
   Barracuda.initAddHeight();
   Barracuda.checkVideos();
   Barracuda.checkMaps();
   Barracuda.formOverlay();
   Barracuda.templateOverlay();
}

/* System for Dynamic colors when overlay inverted elements. */
class BarracudaOverlapping{
   constructor(){
      this.setOverlaping();
      window.addEventListener("scroll", this.setOverlaping.bind(this));
      window.addEventListener("resize", this.setOverlaping.bind(this));
   }
   setOverlaping(){
      document.querySelectorAll(".sidebar .icon svg,.change-color-overlap").forEach(el=>{
            var overlap = false;
            document.querySelectorAll(".use-inverted-colors.full-width, .control-inverted").forEach(background=>{
               if(this.isOverlapping(el, background))
                  overlap = true;
               });
               if(overlap) 
                        el.classList.add("use-inverted-colors");
               else
                        el.classList.remove("use-inverted-colors");
      });
   }
   check(){
      this.setOverlaping();
   }
   isOverlapping(e1, e2){
      if (e1.length && e1.length > 1) {
      e1 = e1[0];
      }
      if (e2.length && e2.length > 1){
      e2 = e2[0];
      }
      const rect1 = e1 instanceof Element ? e1.getBoundingClientRect() : false;
      const rect2 = e2 instanceof Element ? e2.getBoundingClientRect() : false;
      
      let overlap = false;
   
      if (rect1 && rect2) {
      overlap = !(
         rect1.right < rect2.left || 
         rect1.left > rect2.right || 
         rect1.bottom < rect2.top || 
         rect1.top > rect2.bottom
      );
      return overlap;  
      }
   
      console.warn('Not valid HTMLElement object');
      return overlap;
   }
}


class BarracudaAnimatedMenu{
   constructor(){
   this.debug = true;
   this.hidden = false;
   this.menu = document.querySelector(".main-menu");
   this.linksInMenu = this.menu? this.menu.querySelectorAll("ul:not(.child):not(.grandchild)>li"): false;
   
   }
   hideMenuLinks(){
      if(!this.hidden){
         this.hidden = true;
         this.linksInMenu.forEach(function (link) {
            link.dataset.height = link.clientHeight + 1;
            link.style.maxHeight = 0 + "px";
            link.style.overflow = "hidden";
            link.style.transition = "max-height 0.55s cubic-bezier(0.32, 0.08, 0.24, 1)";
         })
      }
   }
   showMenuLinks(i = 0){
      if(i == 0) this.hidden = false;
      var link = this.linksInMenu[i];
      if(link){
         link.style.maxHeight = link.dataset.height + "px";
         setTimeout((function (){this.removeSettings(link)}).bind(this), 1000);
         setTimeout((function (){this.showMenuLinks(++i)}).bind(this), 6);
      }
   }
   removeSettings(link){
      if(link){
         link.style.transition = "";
         link.style.maxHeight = "";
         link.style.overflow = "";
      }
   }
}

class BarracudaRichMedia{
   constructor(element){
      this.element = element;
      this.mediaid = element.dataset.mediaid;
      this.template = document.getElementById("templateid-"+this.mediaid);
      this.container = document.getElementById("containerid-"+this.mediaid);
      this.cover = this.element;
      this.media = null
      this.type = null

      if(this.template && this.container){
         /* Add listener to show button */
         console.log(this.element.parentElement)
         this.element.parentElement.querySelector("button.media-icon").addEventListener("click",this.show.bind(this), false);
      }else{
         console.error("BarracudaRichMedia: Rich media not found - container or template", this.template, this.container)
      }
   }
   getType(){
      if(this.container.querySelector(".js-youtube")){
         this.media = this.container.querySelector(".js-youtube");
         this.type = "youtube";
      }
      if(this.container.querySelector(".js-vimeo")){
         this.media = this.container.querySelector(".js-vimeo");
         this.type = "vimeo";
      }
      if(this.container.querySelector("video")){
         this.media = this.container.querySelector("video");
         this.type = "video";
      }
   }

   play(){
      console.log("BarracudaRichMedia: play", this.mediaid);
      switch(this.type){
         case "youtube":
            this.media.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
            break;
         case "vimeo":
            this.media.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
            break;
         case "video":
            this.media.play();
            break;
      }
   }
   pause(){
      console.log("BarracudaRichMedia: pause", this.mediaid);
      switch(this.type){
         case "youtube":
            this.media.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
            break;
         case "vimeo":
            this.media.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
            break;
         case "video":
            this.media.pause();
            break;
      }
   }
   hide(){
      console.log("BarracudaRichMedia: hide", this.mediaid);
      this.container.innerHTML = "";
      this.cover.classList.remove("hidden");
      this.container.classList.add("hidden");
   }
   show(){
      console.log("BarracudaRichMedia: show", this.mediaid);
      this.cover.classList.add("hidden");
      this.container.classList.remove("hidden");
      this.container.innerHTML = this.template.innerHTML;
      this.getType();

      this.stopOthers();
      this.play();
      setTimeout(this.play.bind(this),100);
   }
   stopOthers(){
      for (const [key, value] of Object.entries(Barracuda.elements.richMedia)) {
         if(key != this.mediaid)
            value.pause();
       }
   }
}

class ProductModel extends HTMLElement {
   constructor() {
     super();  
     Shopify.loadFeatures([
       {
         name: 'model-viewer-ui',
         version: '1.0',
         onLoad: this.setupModelViewerUI.bind(this),
       },
     ]);
   }
   setupModelViewerUI(errors) {
     if (errors) return;
     this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
   }
 }
 customElements.define('product-model', ProductModel);

  /* Hover behavior */
document.querySelectorAll(".primary-menu > li").forEach(function (li) {
    li.addEventListener("mouseenter", function () {
        let arrow = li.querySelector(".icon-custom-down-arrow");
        if (arrow) openSubmenu({ target: arrow, preventDefault: () => {} });
    });

    li.addEventListener("mouseleave", function () {
        let submenu = li.querySelector("ul.child");
        if (submenu) {
            submenu.style.maxHeight = "";
            li.classList.remove("open");
        }
    });
});

// custom bundle dropdown start
// if (document.querySelectorAll('.bundle-item').length != 0 && document.querySelector('.product-price')) {
//   const bundleItems = document.querySelectorAll('.bundle-item'),
//         mainProductPriceElement = document.querySelector('.product-price'),
//         oldPriceHTML = mainProductPriceElement.innerHTML,
//         mainProductP = parseFloat(mainProductPriceElement.getAttribute('data-main-price')),
//         mainProductCP = parseFloat(mainProductPriceElement.getAttribute('data-main-compareprice')) != null ? parseFloat(mainProductPriceElement.getAttribute('data-main-compareprice')) : 0,
//         priceElements = mainProductPriceElement.querySelectorAll('.price, .price-before'),      
//         cart_button = document.querySelector(".barracuda-cart-addToCartButton");
//         let allHamperOptionsSelected = false;
  
//   bundleItems.forEach((item, index) => {
//     const variantSelect = item.querySelector('.bundle_variants');

//     variantSelect.addEventListener('change', () => {
//       let finalPrice = mainProductP;
//       let finalCPrice = mainProductCP;
      
      
//       document.querySelectorAll('.bundle-item').forEach(item => {
//         const variantSelect = item.querySelector('.bundle_variants'),
//               selectedOption = variantSelect.options[variantSelect.selectedIndex];
    
//         const optionPrice = parseFloat(selectedOption.getAttribute('data-price') || 0),
//               optionComparePrice = parseFloat(selectedOption.getAttribute('data-compareprice') || 0);
    
//         finalPrice += optionPrice;
//         finalCPrice += optionComparePrice;

//         if (item.classList.contains('hamper-option') && selectedOption.selected && selectedOption.getAttribute('value') != null) {
//           allHamperOptionsSelected = true;
//         } else if (item.classList.contains('hamper-option') && selectedOption.selected && selectedOption.getAttribute('value') == null) {
//           allHamperOptionsSelected = false;
//         }
//       });

//       if (allHamperOptionsSelected) {
//         if (window.additionalHamperCost.extraCostProducts.hamper_box != null) finalPrice = finalPrice + window.additionalHamperCost.extraCostProducts.hamper_box.price;
//         if (window.additionalHamperCost.extraCostProducts.labour != null) finalPrice = finalPrice + window.additionalHamperCost.extraCostProducts.labour.price;
//         window.hamperfinalPrice = finalPrice;
        
//         if (window.additionalHamperCost.bufferRate != null) finalPrice = finalPrice + (Math.ceil((finalPrice * window.additionalHamperCost.bufferRate/100) / 100) * 100);
//         if (window.additionalHamperCost.gstRate != null) finalPrice = finalPrice + (Math.ceil((finalPrice * window.additionalHamperCost.gstRate/100) / 100) * 100);
                
//         priceElements.forEach(priceElement => {
//           priceElement.textContent = priceElement.classList.contains('price') ? Shopify.formatMoney(finalPrice).replaceAll('.00','') : Shopify.formatMoney(finalCPrice).replaceAll('.00','');
//         });
//         cart_button.classList.remove('disabled');
//       }
//     });
//   });
// }
// // custom bundle dropdown end